module.exports = __webpack_public_path__ + "img/iriomote_8.f8361d8e.jpg";